import styled, { createGlobalStyle } from 'styled-components';

export const GlobalStyle = createGlobalStyle`
  html { scroll-behavior: smooth; }
  body { margin: 0; }
  @media (prefers-reduced-motion: reduce) { html { scroll-behavior: auto; } }
`;

export const Page = styled.div`
  --paper: ${({ $dark }) => ($dark ? '#191c1b' : '#fbf9f4')};
  --ink: ${({ $dark }) => ($dark ? '#f5f1e8' : '#242b28')};
  --muted: ${({ $dark }) => ($dark ? '#b4bcb6' : '#616a63')};
  --line: ${({ $dark }) => ($dark ? '#3a443e' : '#d7dcd1')};
  --accent: ${({ $dark }) => ($dark ? '#e0ed91' : '#465d31')};
  background: var(--paper);
  color: var(--ink);
  min-height: 100vh;
  font-family: 'Helvetica Neue', Helvetica, Arial, sans-serif;
  font-size: 16px;
  line-height: 1.6;
  * {
    box-sizing: border-box;
  }
  ::selection {
    background: #dfeaa8;
    color: #242b28;
  }
  h1,
  h2,
  h3,
  p,
  figure {
    margin: 0;
  }
  a {
    color: inherit;
    text-decoration: none;
  }
  button {
    font: inherit;
  }
  a,
  button,
  summary {
    -webkit-tap-highlight-color: transparent;
  }
  a:focus-visible,
  button:focus-visible,
  summary:focus-visible {
    outline: 2px solid var(--accent);
    outline-offset: 6px;
  }
  .wrap {
    max-width: 1160px;
    margin: auto;
    padding: 0 40px;
  }
  .eyebrow {
    font-size: 13px;
    letter-spacing: 0.09em;
    text-transform: uppercase;
    font-weight: 500;
  }
  .muted {
    color: var(--muted);
  }
  .cascades-frame {
    display: block;
    aspect-ratio: 2 / 1;
    overflow: hidden;
    border-radius: 3px;
  }
  .cascades-frame img {
    display: block;
    width: 100%;
    height: auto;
  }
  .landscapes {
    display: grid;
    gap: 24px;
  }
  .text-link {
    display: inline-flex;
    align-items: center;
    gap: 14px;
    padding: 6px 0;
    border-bottom: 1px solid currentColor;
    font-size: 15px;
  }
  .text-link:hover {
    color: var(--accent);
  }
  .skip {
    position: absolute;
    left: 20px;
    top: -100px;
    z-index: 10;
    padding: 10px 16px;
    background: var(--paper);
  }
  .skip:focus {
    top: 10px;
  }
  section {
    scroll-margin-top: 30px;
  }
  @media (max-width: 700px) {
    .wrap {
      padding: 0 22px;
    }
  }
  @media (prefers-reduced-motion: reduce) {
    *,
    *::before,
    *::after {
      transition: none !important;
      animation: none !important;
    }
  }
`;

export const Header = styled.header`
  min-height: 100px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-bottom: 1px solid var(--line);
  gap: 24px;
  .identity {
    display: flex;
    align-items: center;
    gap: 12px;
    font-weight: 600;
    font-size: 16px;
  }
  img {
    width: 38px;
    height: 38px;
    border-radius: 50%;
    object-fit: cover;
  }
  nav {
    display: flex;
    align-items: center;
    gap: 28px;
    font-size: 14px;
  }
  nav a:hover {
    color: var(--accent);
  }
  button {
    border: 1px solid var(--line);
    border-radius: 50%;
    background: transparent;
    color: var(--ink);
    width: 38px;
    height: 38px;
    cursor: pointer;
  }
  @media (max-width: 600px) {
    min-height: 88px;
    gap: 12px;
    flex-wrap: wrap;
    padding: 18px 0;
    nav {
      gap: 18px;
    }
    .identity span {
      max-width: 90px;
      line-height: 1.25;
    }
  }
  @media (max-width: 380px) {
    nav {
      gap: 12px;
    }
    .identity {
      font-size: 14px;
      gap: 8px;
    }
  }
`;
